import Vue from 'vue'
import axios from 'axios'
import Mixin from './mixins/mixin'

new Vue({
  el: '#app',
  mixins: [Mixin],
  data() {
    return {
      financials: {}
    }
  },
  watch: {
    financialsObj(financialsObj) {
      if (financialsObj && Object.keys(financialsObj).length) {
        financialsObj.forEach(elm => {
          this.financials[elm.fCode] = elm
        })
        console.log(this.financials)
        console.log(Object.keys(this.financials).length)
      }
    }
  },
  created() {
    const self = this
    // 金融機関情報JSON取得
    axios.get(this.apiUrl('financials'))
      .then(res => {
        self.financialsObj = res.data.contents
      }).catch(error => {
        console.log(error)
      })
  }
})
